<div class="rate-management-page">
  <app-smrs-rate-popup 
    [periods]="periods" 
    [isInline]="true"
    class="inline-popup"
    #ratePopup>
  </app-smrs-rate-popup>
</div>
